import React from 'react';
import { constructClassName } from '../../../utils/constructClassName';
import styles from './styles.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Container: React.FC<Props> = ({ children, className }) => (
  <div
    className={constructClassName([
      className,
      styles.container,
    ])}
  >
    {children}
  </div>
);
